import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";

import App from "./App";
import { AppStateProvider } from "./contexts/app";
import reportWebVitals from "./reportWebVitals";
import { theme } from "./style/muiTheme";

import "./style/index.css";
import "./style/appstyle.css";
import "./style/layout.css";
import "./style/bootstrap.min.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <StrictMode>
    <AppStateProvider>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </AppStateProvider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
